import ElementPlus from 'element-plus'
import '../styles/element-variables.scss'
import it from 'element-plus/es/locale/lang/it'

export default (app) => {
    app.use(ElementPlus, {
        locale: it,
    })
}